"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MixedCaseArbitrary = void 0;

var bigUintN_1 = require("../bigUintN");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var Converters_1 = require("../../check/arbitrary/definition/Converters");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var LazyIterableIterator_1 = require("../../stream/LazyIterableIterator");

var ToggleFlags_1 = require("./helpers/ToggleFlags");

var MixedCaseArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(MixedCaseArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(MixedCaseArbitrary);

  function MixedCaseArbitrary(stringArb, toggleCase, untoggleAll) {
    var _this;

    _classCallCheck(this, MixedCaseArbitrary);

    _this = _super.call(this);
    _this.stringArb = stringArb;
    _this.toggleCase = toggleCase;
    _this.untoggleAll = untoggleAll;
    return _this;
  }

  _createClass(MixedCaseArbitrary, [{
    key: "buildContextFor",
    value: function buildContextFor(rawStringNextValue, flagsNextValue) {
      return {
        rawString: rawStringNextValue.value,
        rawStringContext: rawStringNextValue.context,
        flags: flagsNextValue.value,
        flagsContext: flagsNextValue.context
      };
    }
  }, {
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var rawStringNextValue = this.stringArb.generate(mrng, biasFactor);

      var chars = _toConsumableArray(rawStringNextValue.value);

      var togglePositions = (0, ToggleFlags_1.computeTogglePositions)(chars, this.toggleCase);
      var flagsArb = (0, Converters_1.convertToNext)((0, bigUintN_1.bigUintN)(togglePositions.length));
      var flagsNextValue = flagsArb.generate(mrng, undefined);
      (0, ToggleFlags_1.applyFlagsOnChars)(chars, flagsNextValue.value, togglePositions, this.toggleCase);
      return new NextValue_1.NextValue(chars.join(''), this.buildContextFor(rawStringNextValue, flagsNextValue));
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (typeof value !== 'string') {
        return false;
      }

      return this.untoggleAll !== undefined ? this.stringArb.canShrinkWithoutContext(this.untoggleAll(value)) : this.stringArb.canShrinkWithoutContext(value);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this2 = this;

      var contextSafe;

      if (context !== undefined) {
        contextSafe = context;
      } else {
        if (this.untoggleAll !== undefined) {
          var untoggledValue = this.untoggleAll(value);

          var valueChars = _toConsumableArray(value);

          var untoggledValueChars = _toConsumableArray(untoggledValue);

          var togglePositions = (0, ToggleFlags_1.computeTogglePositions)(untoggledValueChars, this.toggleCase);
          contextSafe = {
            rawString: untoggledValue,
            rawStringContext: undefined,
            flags: (0, ToggleFlags_1.computeFlagsFromChars)(untoggledValueChars, valueChars, togglePositions),
            flagsContext: undefined
          };
        } else {
          contextSafe = {
            rawString: value,
            rawStringContext: undefined,
            flags: BigInt(0),
            flagsContext: undefined
          };
        }
      }

      var rawString = contextSafe.rawString;
      var flags = contextSafe.flags;
      return this.stringArb.shrink(rawString, contextSafe.rawStringContext).map(function (nRawStringNextValue) {
        var nChars = _toConsumableArray(nRawStringNextValue.value);

        var nTogglePositions = (0, ToggleFlags_1.computeTogglePositions)(nChars, _this2.toggleCase);
        var nFlags = (0, ToggleFlags_1.computeNextFlags)(flags, nTogglePositions.length);
        (0, ToggleFlags_1.applyFlagsOnChars)(nChars, nFlags, nTogglePositions, _this2.toggleCase);
        return new NextValue_1.NextValue(nChars.join(''), _this2.buildContextFor(nRawStringNextValue, new NextValue_1.NextValue(nFlags, undefined)));
      }).join((0, LazyIterableIterator_1.makeLazy)(function () {
        var chars = _toConsumableArray(rawString);

        var togglePositions = (0, ToggleFlags_1.computeTogglePositions)(chars, _this2.toggleCase);
        return (0, Converters_1.convertToNext)((0, bigUintN_1.bigUintN)(togglePositions.length)).shrink(flags, contextSafe.flagsContext).map(function (nFlagsNextValue) {
          var nChars = chars.slice();
          (0, ToggleFlags_1.applyFlagsOnChars)(nChars, nFlagsNextValue.value, togglePositions, _this2.toggleCase);
          return new NextValue_1.NextValue(nChars.join(''), _this2.buildContextFor(new NextValue_1.NextValue(rawString, contextSafe.rawStringContext), nFlagsNextValue));
        });
      }));
    }
  }]);

  return MixedCaseArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.MixedCaseArbitrary = MixedCaseArbitrary;